import {
  PARTNER_LIST_FIELD_UPDATE,
  PARTNER_LIST_GET_FAILURE,
  PARTNER_LIST_GET_START,
  PARTNER_LIST_GET_SUCCESS,
  PARTNER_CONTRACT_LIST_GET_START,
  PARTNER_CONTRACT_LIST_GET_SUCCESS,
  PARTNER_CONTRACT_LIST_GET_FAILURE,
  PARTNER_GET_START,
  PARTNER_GET_FAILURE,
  PARTNER_GET_SUCCESS,
  PARTNER_VOLUME_DISCOUNT_GET_START,
  PARTNER_VOLUME_DISCOUNT_GET_SUCCESS,
  PARTNER_VOLUME_DISCOUNT_GET_FAILURE,
  PARTNER_VOLUME_DISCOUNT_RESET,
  PARTNER_LIST_RESET,
  PARTNER_CONTRACTS_RESET,
} from "../constants/actionTypes";
import produce from "immer";

const defaultState = {
  list: {
    data: [], // User data
    page: 1,
    count: 0,
  },
  contracts: {
    list: {
      data: [],
      page: 1,
      count: 0,
    },
  },
  item: {
    name: "",
    registrationNr: "",
    address: "",
  },
  volumeDiscounts: [],
  loading: false,
};

/* eslint-disable default-case */
/**
 * Redux reducer for partners
 * @param state
 * @param action
 */
const partnerReducer = (state = defaultState, action) =>
  produce(state, draft => {
    const { payload, type } = action;
    switch (type) {
      case PARTNER_GET_START: {
        draft.name = "";
        draft.registrationNr = "";
        draft.address = "";
        draft.loading = true;
        break;
      }

      case PARTNER_GET_SUCCESS: {
        draft.item = { ...payload };
        draft.loading = false;
        break;
      }

      case PARTNER_GET_FAILURE: {
        draft.name = "";
        draft.registrationNr = "";
        draft.address = "";
        draft.loading = false;
        break;
      }

      case PARTNER_LIST_GET_START: {
        draft.list.data = [];
        draft.list.count = 0;
        draft.loading = true;
        break;
      }

      case PARTNER_LIST_GET_SUCCESS: {
        draft.list.data = payload.data.rows;
        draft.list.count = payload.data.count;
        draft.page = payload.page;
        draft.loading = false;
        break;
      }

      case PARTNER_LIST_GET_FAILURE: {
        draft.list.data = [];
        draft.list.count = 0;
        draft.loading = false;
        break;
      }

      case PARTNER_CONTRACT_LIST_GET_START: {
        draft.contracts.list = {
          data: [],
          page: 1,
          count: 0,
        };
        draft.loading = true;
        break;
      }

      case PARTNER_CONTRACT_LIST_GET_SUCCESS: {
        draft.contracts.list = {
          data: payload.data.rows,
          page: payload.data.count,
          count: payload.page,
        };
        draft.loading = false;
        break;
      }

      case PARTNER_CONTRACT_LIST_GET_FAILURE: {
        draft.contracts.list = {
          data: [],
          page: 1,
          count: 0,
        };
        draft.loading = false;
        break;
      }

      case PARTNER_VOLUME_DISCOUNT_GET_FAILURE: {
        draft.volumeDiscounts = [];
        draft.loading = false;
        break;
      }
      case PARTNER_VOLUME_DISCOUNT_GET_SUCCESS: {
        draft.volumeDiscounts = payload;
        draft.loading = false;
        break;
      }
      case PARTNER_VOLUME_DISCOUNT_GET_START: {
        draft.loading = true;
        break;
      }

      case PARTNER_VOLUME_DISCOUNT_RESET: {
        draft.volumeDiscounts = defaultState.volumeDiscounts;
        break;
      }

      case PARTNER_LIST_RESET: {
        draft.list = defaultState.list;
        break;
      }

      case PARTNER_CONTRACTS_RESET: {
        draft.contracts = defaultState.contracts;
        break;
      }

      // skip default
    }
  });

export default partnerReducer;
